import * as types from '../constants/gear';
import { mapErrorMessage } from '../../Utils/mapErrorMessage';
import { toast } from 'react-toastify';
import parseDjangoError from '../../Utils/parseDjangoError';

const INITIAL_STATE = {
  isLoading: false,
  success: false,
  error: null,
  instanceDetails: null,
  instanceDetailsErr: null,

  orgRobots: [],
  shootRobots: [],
  robotAirIdValidation: {},
  bulkOnboardResult: null,
  inventoryOnPremServerInfo: {},
  orgInstances: [],
  shootInstances: [],
  shootInstanceLiveStatuses: [],
  orgOnPremServers: []
};

let toastId = null;

export default function gearApiReducer(state = INITIAL_STATE, action) {
  const newState = JSON.parse(JSON.stringify(state));

  switch (action.type) {
    case types.CLEAR_INSTANCE_DETAILS:
      return {
        ...state,
        instanceDetails: null,
        instanceDetailsErr: null,
      };

    // TESTING
    case types.API_RESET_ALL_GEARS:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: null,
        orgGears: [],
        orgInstances: [],
      };

    case types.API_GET_ALL_ORG_ROBOTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case types.API_GET_ALL_ORG_ROBOTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        orgRobots: action.response.data.result,
      };
    case types.API_GET_ALL_ORG_ROBOTS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_BULK_ONBOARD_ORG_ROBOT_REQUEST:
      // Don't set isLoading: it swaps the page to <Loader/> and unmounts the
      // OnboardRobot sidebar mid-request. Loading feedback is the saga's toast.
      return {
        ...state,
        success: false,
        // Reset so a non-null bulkOnboardResult always means "this submit".
        bulkOnboardResult: null,
      };
    case types.API_BULK_ONBOARD_ORG_ROBOT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        bulkOnboardResult: action.payload?.result || {},
      };
    case types.API_BULK_ONBOARD_ORG_ROBOT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
      };

    case types.API_VALIDATE_ROBOT_AIR_ID_REQUEST:
      return {
        ...state,
        robotAirIdValidation: {
          ...state.robotAirIdValidation,
          [action.airId]: { loading: true, valid: false, nickName: '' },
        },
      };
    case types.API_VALIDATE_ROBOT_AIR_ID_SUCCESS: {
      // nick_name is only present when claimable.
      const { valid = false, nick_name = '' } = action.payload || {};
      return {
        ...state,
        robotAirIdValidation: {
          ...state.robotAirIdValidation,
          [action.airId]: { loading: false, valid, nickName: nick_name },
        },
      };
    }
    case types.API_VALIDATE_ROBOT_AIR_ID_FAILED:
      return {
        ...state,
        robotAirIdValidation: {
          ...state.robotAirIdValidation,
          [action.airId]: {
            loading: false,
            valid: false,
            nickName: '',
            error: action.payload || 'Invalid AIR ID',
          },
        },
      };
    case types.API_CLEAR_ROBOT_AIR_ID_VALIDATION:
      return {
        ...state,
        robotAirIdValidation: {},
      };
    case types.API_CLEAR_BULK_ONBOARD_RESULT:
      return {
        ...state,
        bulkOnboardResult: null,
      };

    case types.API_UPDATE_ORG_ROBOT_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };
    case types.API_UPDATE_ORG_ROBOT_SUCCESS:
      toast.success('Successfully update Robot robot settings', {
        autoClose: 3000,
        closeOnClick: true,
      });
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        orgRobots: [
          ...state.orgRobots?.map(orgRobot =>
            orgRobot.id === action.response.data.result?.id
              ? action.response.data.result
              : orgRobot,
          ),
        ],
      };
    case types.API_UPDATE_ORG_ROBOT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_GET_ALL_SHOOT_ROBOT_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };
    case types.API_GET_ALL_SHOOT_ROBOT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        shootRobots: action.response.data.result,
      };
    case types.API_GET_ALL_SHOOT_ROBOT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_CREATE_SHOOT_ROBOT_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };
    case types.API_CREATE_SHOOT_ROBOT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        shootRobots: [action.response.data.result, ...state.shootRobots],
      };
    case types.API_CREATE_SHOOT_ROBOT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_UPDATE_SHOOT_ROBOT_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };
    case types.API_UPDATE_SHOOT_ROBOT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        shootRobots: [
          ...state.shootRobots?.map(shootRobot =>
            shootRobot.id === action.response.data.result?.id
              ? action.response.data.result
              : shootRobot,
          ),
        ],
      };
    case types.API_UPDATE_SHOOT_ROBOT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_DELETE_SHOOT_ROBOT_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };
    case types.API_DELETE_SHOOT_ROBOT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case types.API_DELETE_SHOOT_ROBOT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_CLEAR_ALL_SHOOT_ROBOTS_REQUEST:
      return {
        ...state,
        shootRobots: [],
      };

    case types.API_GET_ALL_ORG_INSTANCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case types.API_GET_ALL_ORG_INSTANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        orgInstances: action.response.data.result,
      };
    case types.API_GET_ALL_ORG_INSTANCE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_ONBOARD_ORG_INSTANCE_REQUEST:
      toastId = toast.loading('Onboarding Instance. Please wait a second...');
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case types.API_ONBOARD_ORG_INSTANCE_SUCCESS:
      toast.update(toastId, {
        render: 'Instance onboarded successfully!',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        orgInstances: [action.response.data.result, ...state.orgInstances],
      };
    case types.API_ONBOARD_ORG_INSTANCE_FAILED:
      toast.update(toastId, {
        render: 'Instance onboarded failed!',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_UPDATE_ORG_INSTANCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };
    case types.API_UPDATE_ORG_INSTANCE_SUCCESS:
      toast.success('Successfully update Instance settings', {
        autoClose: 3000,
        closeOnClick: true,
      });
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        orgInstances: [
          ...state.orgInstances?.map(airInstance =>
            airInstance.id === action.response.data.result?.id
              ? action.response.data.result
              : airInstance,
          ),
        ],
      };
    case types.API_UPDATE_ORG_INSTANCE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_GET_ALL_SHOOT_INSTANCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };
    case types.API_GET_ALL_SHOOT_INSTANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        shootInstances: action.response.data.result,
      };
    case types.API_GET_ALL_SHOOT_INSTANCE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_CREATE_SHOOT_INSTANCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };
    case types.API_CREATE_SHOOT_INSTANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        shootInstances: [action.response.data.result, ...state.shootInstances],
      };
    case types.API_CREATE_SHOOT_INSTANCE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_UPDATE_SHOOT_INSTANCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };
    case types.API_UPDATE_SHOOT_INSTANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        shootInstances: [
          ...state.shootInstances?.map(airInstanceAssignedToProject =>
            airInstanceAssignedToProject.id === action.response.data.result?.id
              ? action.response.data.result
              : airInstanceAssignedToProject,
          ),
        ],
      };
    case types.API_UPDATE_SHOOT_INSTANCE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_DELETE_SHOOT_INSTANCE_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };
    case types.API_DELETE_SHOOT_INSTANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case types.API_DELETE_SHOOT_INSTANCE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_REQUEST:
      // No isLoading: background poll shouldn't collapse the Launchpad canvas.
      return {
        ...state,
        success: false,
        error: null,
      };
    case types.API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_SUCCESS:
      if (action.response.data.error.length) {
        toast.error(action.response.data.error);
      }
      return {
        ...state,
        isLoading: false,
        success: true,
        shootInstanceLiveStatuses: action.response.data.result,
      };
    case types.API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_FAILED:
      toast.error(action.error.message)
      return {
        ...state,
        success: false,
        error: action.error.message,
      };

    case types.API_GET_SHOOT_INSTANCE_LIVE_STATUS_REQUEST:
      return {
        ...state,
        success: false,
        error: null,
      };
    case types.API_GET_SHOOT_INSTANCE_LIVE_STATUS_SUCCESS:
      return {
        ...state,
        success: true,
        shootInstanceLiveStatuses: [
          ...state.shootInstanceLiveStatuses?.map(shootInstanceLiveStatus =>
          shootInstanceLiveStatus.air_id === action.response.data.result?.air_id
            ? { ...shootInstanceLiveStatus, ...action.response.data.result }
            : shootInstanceLiveStatus
        )]
      };
    case types.API_GET_SHOOT_INSTANCE_LIVE_STATUS_FAILED:
      toast.error(action.error.message)
      return {
        ...state,
        success: false,
        error: action.error.message,
      };

    case types.API_START_SHOOT_INSTANCE_REQUEST:
      return {
        ...state,
        success: false,
        error: null,
      };
    case types.API_START_SHOOT_INSTANCE_SUCCESS:
      toast.success(action.response.data.result)
      return {
        ...state,
        success: true,
      };
    case types.API_START_SHOOT_INSTANCE_FAILED:
      toast.error(action.error.message)
      return {
        ...state,
        success: false,
        error: action.error.message,
      };

    case types.API_STOP_SHOOT_INSTANCE_REQUEST:
      return {
        ...state,
        success: false,
        error: null,
      };
    case types.API_STOP_SHOOT_INSTANCE_SUCCESS:
      toast.success(action.response.data.result)
      return {
        ...state,
        success: true,
      };
    case types.API_STOP_SHOOT_INSTANCE_FAILED:
      toast.error(action.error.message)
      return {
        ...state,
        success: false,
        error: action.error.message,
      };

    case types.API_GET_INVENTORY_ON_PREM_SERVER_INFO_SUCCESS:
      return {
        ...state,
        inventoryOnPremServerInfo: action.payload,
      };

    case types.API_CLEAR_INVENTORY_ON_PREM_SERVER_REQUEST:
      return {
        ...state,
        inventoryOnPremServerInfo: {},
      };

    case types.API_ONBOARD_ORG_ON_PREM_SERVER_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case types.API_ONBOARD_ORG_ON_PREM_SERVER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        orgOnPremServers: [action.payload, ...state.orgOnPremServers],
      };
    case types.API_ONBOARD_ORG_ON_PREM_SERVER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
      };

    case types.API_ONBOARD_ORG_ON_PREM_SERVER_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case types.API_ONBOARD_ORG_ON_PREM_SERVER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        orgOnPremServers: [action.payload, ...state.orgOnPremServers],
      };
    case types.API_ONBOARD_ORG_ON_PREM_SERVER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
      };

    case types.API_UPDATE_ORG_ON_PREM_SERVER_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case types.API_UPDATE_ORG_ON_PREM_SERVER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        orgOnPremServers: [
          ...state.orgOnPremServers?.map(server =>
            server.id === action.payload?.id ? action.payload : server,
          ),
        ],
      };
    case types.API_UPDATE_ORG_ON_PREM_SERVER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
      };

    case types.API_GET_ALL_ORG_ON_PREM_SERVERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case types.API_GET_ALL_ORG_ON_PREM_SERVERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        orgOnPremServers: action.payload,
      };
    case types.API_GET_ALL_ORG_ON_PREM_SERVERS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
}